// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordPage":"ForgotPasswordModal_forgotPasswordPage__hHCiN","userEmail":"ForgotPasswordModal_userEmail__0uaUm"};